module.exports = __webpack_public_path__ + "static/img/level_off.6a6cecdb.png";